import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function getTicketDetails(payload) {
  try {
    const url = `${URL.getTicketDetails}/${payload.ticket_id}`;
    const data = await authenticatedFetch(url);
    return data;
  } catch (error) {
    console.error("Error executing ticket details:", error);
    throw error;
  }
}
